// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dni0","name":"styles_name__ibVlq","phone":"styles_phone__1dO1z"};